<template>
  <div class="login-new" :class="bgColor">
    <div class="title">{{ $t("login.title") }}</div>
    <Tabs :activeId="tabsActive" @change="change" />
    <div class="main">
      <LoginPassword
        v-show="tabsActive == 1"
        :user-info="storageUserInfo">
      </LoginPassword>
      <LoginMessage
        v-show="tabsActive == 2"
        :user-info="storageUserInfo">
      </LoginMessage>
    </div>
  </div>
</template>

<script>
import Tabs from "./components/Tabs.vue";
import LoginPassword from "./components/LoginPassword.vue";
import LoginMessage from "./components/LoginMessage.vue";
export default {
  components: {
    Tabs,
    LoginPassword,
    LoginMessage
  },
  computed: {
    bgColor() {
      return this.$store.getters["common/bgColor"];
    }
  },
  data() {
    return {
      tabsActive: 1, // 当前选中 tabs
      storageUserInfo: {}
    };
  },
  created() {
    this.$getStorageApp("login_mode",(e) =>{
      this.tabsActive = e || 1;
    });
    let h5RememberPwd = localStorage.getItem("h5RememberPwd");
    if(h5RememberPwd){
      h5RememberPwd = JSON.parse(h5RememberPwd);
      this.storageUserInfo = h5RememberPwd;
    }
  },
  methods: {
    // 切换顶部tab
    change(id) {
      this.tabsActive = id;
      this.$setStorageApp("login_mode", id);
    },
  }
};
</script>

<style scoped lang="less">
.login-new {
  padding: 60px 50px 0;
  box-sizing: border-box;
  height: 100vh;
  overflow: hidden;
  position: relative;
  .title {
    font-size: 48px;
    font-weight: bold;
  }
  .main{
    &.agreementAni{
      @keyframes agreementAni{
        0%, 40%,80%, 100%{
          transform: translateX(0px);
        }
        20%{
          transform: translateX(-20px);
        }
        60%{
          transform: translateX(-10px);
        }
        90%{
          transform: translateX(-4px);
        }
      }
      /deep/ .agreement-box{
        animation: agreementAni .5s ease both;
      }
    }
  }
  .link-box {
    margin-top: 60px;
    display: flex;
    justify-content: space-between;
    .link {
      color: #377CFB;
    }
  }
  .faceId-box {
    position: absolute;
    bottom: 100px;
    left: 0;
    width: 100%;
    text-align: center;
  }


  /deep/ input {
    background-color: rgba(0,0,0,0) !important; /* 默认背景色 */
    &:-webkit-autofill {
      box-shadow: 0 0 0px 1000px rgba(0,0,0,0) inset; /* 修改自动填充的背景色 */
      background-color: rgba(0,0,0,0) !important; /* 自动填充后的背景色 */
      transition: background-color 5000s ease-in-out 0s; /* 防止背景色跳转 */

    }
  }

  &.black-theme{
    color: #fff;
    /deep/ input {
      &:-webkit-autofill {
        -webkit-text-fill-color: #fff;
      }
    }
    /deep/ .custom-field__value .eye {
      background-color: rgba(0,0,0,0);
    }
    /deep/ .tabs{
      .item{
        color: #fff;
        &:after{
          background: #fff;
        }
      }
    }
    /deep/ .form{
      .agreement-box{
        .link{
          color: #377CFB;
        }
      }
      .btn-submit{
        background: #377CFB;
        color: #fff;
      }
    }
    .link-box{
      .link{
        color: #377CFB;
      }
    }
  }
}
</style>
